function Device() {
    return (
        <div>
            <div class="device" id="devices">
                <div class="contianer">
                    <div class="row align-content-center d-flex">
                        <div class="col-md-5">
                            <img src="img/project.PNG" class="img-fluid" alt=""></img>
                        </div>
                        <div class="col-md-6 align-content-center d-flex  mt-5 pt-5">
                            <div class="row text-center ">
                                <div class="col-md-6">
                                    <i class="fa-solid fa-phone hart-icon "></i>
                                    <br></br>
                                        <h2>Device Mockups</h2>
                                        <h5>Ready to use HTML/CSS device mockups, no Photoshop required!</h5>
                                </div>
                                <div class="col-md-6">
                                    <i class="fa-solid fa-heart hart-icon"></i>
                                    <br></br>
                                        <h2>Flexible Use</h2>
                                        <h5>Put an image, video, animation, or anything else in the screen!</h5>
                                </div>
                                <div class="col-md-6">
                                    <i class="fa-solid fa-user hart-icon"></i>
                                    <br></br>
                                        <h2>Free to Use</h2>
                                        <h5>As always, this theme is free to download and use for any purpose!</h5>
                                </div>
                                <div class="col-md-6">
                                    <i class="fa-brands fa-github hart-icon"></i>
                                    <br></br>
                                        <h2>Open Source</h2>
                                        <h5>Since this theme is MIT licensed, you can use it commercially!</h5>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Device;